import React from 'react';
import { createUseStyles } from 'react-jss';
import PropTypes from 'prop-types';
import Notification from './Notification';
const useStyles = createUseStyles({
  root: {}
});
const Notifications = ({
  notifications
}) => {
  const classes = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, notifications.map(notification => /*#__PURE__*/React.createElement(Notification, {
    notification: notification
  })));
};
Notifications.propTypes = {
  notifications: PropTypes.array
};
export default Notifications;